import {
    createStore
} from 'vuex'
import {
    dayjs
} from 'element-plus'
export default createStore({
    state: {
        today: '',
        yesterday: '',
        lastweek: '',
        lastmonth: '',
        month: '',
        uri: '',
        defaulturi: '',
        tab: [],
        innerHeight: 0,
        screenWidth: 0,
        route: [],
        tabs: {},
        uname: '',
        akey: '',
        domain: '',
        postlist: [],
        postvalue: '',
        hide: 0,
    },
    getters: {
        today: state => state.today,
        tabs: state => state.tabs,
        yesterday: state => state.yesterday,
        lastweek: state => state.lastweek,
        lastmonth: state => state.lastmonth,
        uri: state => state.uri,
        tab: state => state.tab,
        defaulturi: state => state.defaulturi,
        hide: state => state.hide,
        innerHeight: state => state.innerHeight,
        screenWidth: state => state.screenWidth,
        route: state => state.route,
        uname: state => state.uname,
        akey: state => state.akey,
        postlist: state => state.postlist,
        postvalue: state => state.postvalue,
        domain: state => state.domain,
    },
    mutations: {
        SETURI(state, data) {
            state.uri = data.path
            state.tab = state.tabs[data.path] ?? []
            state.defaulturi = data.query.id
        },
        SETTAB(state, data) {
            state.tab = data
        },
        SETABS(state, data) {
            state.tabs[data.key] = data.vl
        },
        SETHIDE(state, data) {
            state.hide = data
        },
        SETUNAME(state, data) {
            state.uname = data
        },
        SETAKEY(state, data) {
            let akey = ''
            let postlist = []
            if (data.includes('@')) {
                let parts1 = data.split('@');
                akey = parts1[0]
                postlist = parts1[1].split(',')
            }
            state.akey = akey
            state.postlist = postlist
            let postvalue = window.localStorage.getItem('postvalue')
            if (!postvalue) {
                postvalue = postlist.length ? postlist[0] : ''
                window.localStorage.setItem('postvalue', postvalue)
            }
            state.postvalue = postvalue
        },
        SETIH(state, data) {
            state.innerHeight = data
        },
        SETSW(state, data) {
            state.screenWidth = data
        },
        SETROUTE(state, data) {
            state.route = data
        },
        SETODAY(state) {
            let date = new Date()
            state.today = dayjs(date.getTime()).format('YYYY-MM-DD')
            state.yesterday = dayjs(date.getTime() - 3600 * 1000 * 24).format('YYYY-MM-DD')
            state.month = dayjs(date.getTime()).format('YYYY-MM')
            state.lastweek = dayjs(date.getTime() - 3600 * 1000 * 24 * 7).format('YYYY-MM-DD')
            state.lastmonth = dayjs(date.getTime() - 3600 * 1000 * 24 * 30).format('YYYY-MM-DD')
            // 根据环境动态设置上传地址
            const domain = window.location.protocol + '//' + window.location.host;
            state.domain = domain
        },
    },
    actions: {
        SETIH({
            commit
        }, data) {
            commit('SETIH', data)
        },
        SETABS({
            commit
        }, data) {
            commit('SETABS', data)
        },
        SETHIDE({
            commit
        }, data) {
            commit('SETHIDE', data)
        },
        SETAKEY({
            commit
        }, data) {
            commit('SETAKEY', data)
        },
        SETUNAME({
            commit
        }, data) {
            commit('SETUNAME', data)
        },
        SETROUTE({
            commit
        }, data) {
            commit('SETROUTE', data)
        },
        SETSW({
            commit
        }, data) {
            commit('SETSW', data)
        },
        SETURI({
            commit
        }, data) {
            commit('SETURI', data)
        },
        SETODAY({
            commit
        }, data) {
            commit('SETODAY', data)
        }
    },
    modules: {}
})